/**
 * Dev Tools is a developer-only panel that simulates physical hardware
 * (Kodak scanner, Zebra printer, Zebra barcode scanner). Access is gated
 * by the signed-in user's email: only emails in `DEV_TOOLS_ALLOWED_EMAILS`
 * (defaults to `admin@gmail.com`; override with
 * `NEXT_PUBLIC_DEV_TOOLS_EMAILS=a@x.com,b@y.com`) can see the route or
 * the dev-tools-only controls embedded in other pages.
 */

const DEFAULT_ALLOWED_EMAIL = 'admin@gmail.com';

export const DEV_TOOLS_ALLOWED_EMAILS: readonly string[] = (
  process.env.NEXT_PUBLIC_DEV_TOOLS_EMAILS ?? DEFAULT_ALLOWED_EMAIL
)
  .split(',')
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

export function isDevToolsAllowedForEmail(
  email: string | null | undefined
): boolean {
  if (!email) return false;
  return DEV_TOOLS_ALLOWED_EMAILS.includes(email.trim().toLowerCase());
}

export const DEFAULT_SCAN_DELAY_MS = 400;
export const MIN_SCAN_DELAY_MS = 50;
export const MAX_SCAN_DELAY_MS = 5000;

// Default thermal label dimensions for ZT610/ZT410 single-sticker mode.
// Common Zebra QR sticker sizes; user can override in the form.
export const DEFAULT_STICKER_WIDTH_MM = 12.7;
export const DEFAULT_STICKER_HEIGHT_MM = 12.7;
